import { render, staticRenderFns } from "./svgLinkedin.vue?vue&type=template&id=5708a260&scoped=true"
import script from "./svgLinkedin.vue?vue&type=script&lang=js"
export * from "./svgLinkedin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5708a260",
  null
  
)

export default component.exports